import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})




export class NotificationComponent implements OnInit {

  dataSource: MatTableDataSource<any>;
  markReadNotification = []
  markUnReadNotification = []
  msg;
  user;
  notificationCounts;
  columnsToDisplay = ['Title', 'Content', 'Time', 'Status', 'Views'];
  // dataSource
  expandedElement: PeriodicElement | null
  noDataMsg = {
    title: "No Notifications!",
    data: "You have not any notification yet!"
  }
  loading = false
  isMark = false
  pageSize = 5;
  afterFilter: any;
  filterActive: Boolean = false;
  paginator: MatPaginator;
  sort: MatSort;
  allNotification: any = [];
  allMark
  currentUser
  allReadArray: any = []
  selectAllNotDisplay: boolean = false;
  isRead: boolean = true;
  flag: boolean = false
  displayText1 = 'Unread Notification'
  displayText2 = 'Read Notification'

  constructor(
    public notificationService: NotificationService,
    public route: Router,
    private cd: ChangeDetectorRef
  ) {
    this.dataSource = new MatTableDataSource<any>([]);
    let temp = this.notificationService.getNotificationCount()
    console.log("%ctemp in notification componenet", 'color:purple', temp)
  }



  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit() {
    this.getNotification()
    this.user = JSON.parse(localStorage.getItem("userRoles"));
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    console.log("current user role ==>", this.user)
    let temp = this.notificationService.getNotificationCount()
    console.log("%ctemp in notification componenet", 'color:purple', temp)
    // console.log("this user data counts ==>", this.notificationCounts)

  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }



  updateData(notification) {
    console.log("UPDATING DATA = ", notification)
    this.dataSource = new MatTableDataSource(notification);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
  }

  // API CALL


  getNotification() {
    this.loading = true
    this.notificationService.getNotifications(this.flag).subscribe((response: any) => {
      this.isRead = false
      console.log("response of all notification", response);
      if (response && response.count && response.count != 0) {
        this.notificationCounts = response.count
      } else {
        this.notificationCounts = 0
      }
      if (response && response.list && response.list.length) {
        // console.log("check r")
        this.allNotification = response.list

        // this.dataSource = new MatTableDataSource(response.list);
        // this.dataSource = this.dataSource;
        this.notificationSetSequence()
        // this.dataSource = this.markUnReadNotification.concat(this.markReadNotification)
        // this.dataSource = this.dataSource;

      } else {
        this.filterActive = true
        this.allNotification = []
        this.updateData([])
      }

      setTimeout(() => {

        this.loading = false
      }, 1000)

      // this.cd.detectChanges()
    }, error => {
      console.log("error while get all notificatoin", error);
      this.loading = false
    })


  }


  markRead(data, i) {
    this.isMark = true
    console.log("check the notification data ==>", data)
    let currentnotification = data;
    currentnotification.isRead = true;

    this.allNotification.splice(i, 1, data)
    this.markReadNotification = this.allNotification.filter((item) => {
      return item.isRead == true;
    })



    console.log("mark read notification list ", this.markReadNotification)

    this.markReadNotification = this.markReadNotification.sort((a, b) => {
      return <any>new Date(b.createdAt) - <any>new Date(a.createdAt);
    });;

    this.markUnReadNotification = this.allNotification.filter((item) => {
      return item.isRead == false;

    })
    // this.markUnReadNotification = this.markUnReadNotification.reverse();
    this.markUnReadNotification = this.markUnReadNotification.sort((a, b) => {
      return <any>new Date(b.createdAt) - <any>new Date(a.createdAt);
    });;
    console.log("mark unread notification list ", this.markUnReadNotification)

    this.updateData(this.markUnReadNotification.concat(this.markReadNotification))
    // this.dataSource = this.markUnReadNotification.concat(this.markReadNotification)
    let id = data._id;
    this.notificationService.markRead(id).subscribe((response: any) => {
      console.log("response Mark As Read:", response)
      this.getNotification()
      this.isMark = false
    }, error => {
      console.log("error while get mark as read notification", error)
      this.isMark = false
    })


  }



  // allMarkFunction() {

  //   for (var i = 0; i < this.allNotification.length; i++) {
  //     // let singleItem = this.allNotification[i]
  //     // singleItem['isSelect'] = false
  //     // this.allNotification[i] = singleItem
  //     if (this.allNotification[i].isRead == false) {
  //       this.allNotification[i].isSelect = this.allMark;
  //     }
  //     if (this.allNotification[i].isSelect == true) {
  //       this.allNotification[i].isSelect = this.allMark;
  //     }
  //   }
  //   this.allReadArray = []

  // }





  mark(i) {
    this.allReadArray = this.allNotification.filter((item) => {
      return item.isSelect == true;
    })
    console.log("here is is checked Notification ===>", this.allReadArray)
  }


  // allRead() {
  //   this.allMark = false
  //   this.allReadArray = this.allNotification.filter((item) => {
  //     return item.isSelect == true;
  //   })


  //   let temp = []
  //   for (var i = 0; i < this.allReadArray.length; i++) {
  //     temp.push(this.allReadArray[i]._id)
  //   }

  //   console.log("here is finall notification array ", temp)

  //   let userId
  //   if (this.user && this.user.isAdmin) {
  //     userId = this.currentUser._id
  //   }
  //   else {
  //     userId = this.currentUser.userId
  //   }

  //   let finalData = {
  //     notificationList: temp,
  //     userId: userId
  //   }
  //   this.notificationService.allRead(finalData).subscribe((data) => {
  //     console.log("here is the notification response ===>", data)
  //     for (var i = 0; i < this.allReadArray.length; i++) {
  //       this.allReadArray[i].isRead = true
  //     }

  //     this.notificationSetSequence()
  //     this.getNotification()
  //   }, (error) => {
  //     console.log("some error occure mark as read Data", error)
  //   })
  // }


  viewRead(data) {
    console.log("data====>", data);
    this.loading = true
    this.selectAllNotDisplay = true
    if (!data) {
      this.flag = true
      this.isRead = false
      this.notificationService.getNotifications(this.flag).subscribe((response: any) => {
        this.isRead = true
        console.log("response of all notification", response);
        if (response && response.count && response.count != 0) {
          this.notificationCounts = response.count
        } else {
          this.notificationCounts = 0
        }
        if (response && response.list && response.list.length) {
          // console.log("check r")
          this.allNotification = response.list
  
          // this.dataSource = new MatTableDataSource(response.list);
          // this.dataSource = this.dataSource;
          this.notificationSetSequence()
          // this.dataSource = this.markUnReadNotification.concat(this.markReadNotification)
          // this.dataSource = this.dataSource;
  
        } else {
          this.filterActive = true
          this.allNotification = []
          this.updateData([])
        }
  
        setTimeout(() => {
  
          this.loading = false
        }, 1000)
  
        // this.cd.detectChanges()
      }, error => {
        console.log("error while get all notificatoin", error);
        this.loading = false
      })
    } else {
      this.selectAllNotDisplay = false
      this.flag = false
      this.isRead = true
      this.getNotification()
    }

  }

  getText() {
    if (this.isRead) return true
    else return false
  }

  // redirect(link) {
  //   console.log("what is in link", link);

  // }

  allMarkFunction() {

    for (var i = 0; i < this.allNotification.length; i++) {
      // let singleItem = this.allNotification[i]
      // singleItem['isSelect'] = false
      // this.allNotification[i] = singleItem
      if (this.allNotification[i].isRead == false) {
        this.allNotification[i].isSelect = this.allMark;
      }
      if (this.allNotification[i].isSelect == true) {
        this.allNotification[i].isSelect = this.allMark;
      }
    }
    this.allReadArray = []

  }


  allRead() {
    this.allMark = false
    this.allReadArray = this.allNotification.filter((item) => {
      return item.isSelect == true;
    })


    let temp = []
    for (var i = 0; i < this.allReadArray.length; i++) {
      temp.push(this.allReadArray[i]._id)
    }

    console.log("here is finall notification array ", temp)

    let userId
    if (this.user && this.user.isAdmin) {
      userId = this.currentUser._id
    }
    else {
      userId = this.currentUser.userId
    }

    // let finalData={
    //    notificationList:temp,
    //    userId:userId
    // }
    this.notificationService.allRead(temp).subscribe((data) => {
      console.log("here is the notification response ===>", data)
      for (var i = 0; i < this.allReadArray.length; i++) {
        this.allReadArray[i].isRead = true
      }
      this.notificationSetSequence()
      this.getNotification()
    }, (error) => {
      console.log("some error occure mark as read Data", error)
    })
  }

  
  // viewUnread() {
  //   this.selectAllNotDisplay = false
  //   this.flag = false
  //   this.isRead = true
  //   this.getNotification()
  // }

  // redirect(link) {
  //   console.log("what is in link", link);

  // }

 


  


  notificationSetSequence() {

    for (var i = 0; i < this.allNotification.length; i++) {
      let singleItem = this.allNotification[i]
      singleItem['isSelect'] = false
      this.allNotification[i] = singleItem
    }


    this.markReadNotification = this.allNotification.filter((item) => {
      return item.isRead == true;
    })
    console.log("mark read notification list ", this.markReadNotification)

    this.markReadNotification = this.markReadNotification.reverse();

    this.markUnReadNotification = this.allNotification.filter((item) => {
      return item.isRead == false;
    })
    this.markUnReadNotification = this.markUnReadNotification.reverse();

    console.log("mark unread notification list ", this.markUnReadNotification)
    console.log("this is final notification count", this.notificationCounts);
    this.updateData(this.markUnReadNotification.concat(this.markReadNotification))

  }


  redirect(link, params) {
    console.log("url to be change", link, params);

    this.route.navigate([link], { queryParams: params });
  }


}




// export class TableExpandableRowsExample {
//   dataSource = this.dataSource;
//   columnsToDisplay = ['name', 'weight', 'symbol', 'position'];
//   expandedElement: PeriodicElement | null;
// }

export interface PeriodicElement {
  name: string;
  position: string;
  weight: string;
  symbol: string;
  description: string;
}